import React, { useState, useEffect } from 'react';
import './PreviewModal.css';

const PreviewModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [title, setTitle] = useState('Документ');
    const [url, setUrl] = useState('about:blank');

    const openPreview = (newUrl, newTitle) => {
        setTitle(newTitle || 'Документ');
        setUrl(newUrl || 'about:blank');
        setIsOpen(true);
        document.body.style.overflow = 'hidden';
    };

    const closePreview = () => {
        setIsOpen(false);
        setUrl('about:blank');
        document.body.style.overflow = '';
    };

    useEffect(() => {
        const handleClick = (e) => {
             const el = e.target.closest('[data-preview-url]');
             if (el) {
                e.preventDefault();
                openPreview(el.getAttribute('data-preview-url'), el.getAttribute('data-preview-title'));
             }
        }
        document.addEventListener('click', handleClick);

        const handleKeydown = (e) => {
            if (e.key === 'Escape' && isOpen) closePreview();
        }
        document.addEventListener('keydown', handleKeydown);

        return () => {
            document.removeEventListener('click', handleClick);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [isOpen]);


    if (!isOpen) return null;

  return (
    <div className="modal" aria-hidden={!isOpen} role="dialog" aria-modal="true" aria-label="Предпросмотр документа" onClick={closePreview}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-top">
          <div className="modal-title">{title}</div>
          <button className="swiper-btn" type="button" aria-label="Закрыть" onClick={closePreview}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>
        <iframe src={url} title="Предпросмотр"></iframe>
      </div>
    </div>
  );
};

export default PreviewModal;
